import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { API_URI } from 'src/constants';

const Header = dynamic(import('src/components/layouts/header'), { ssr: true });
const Footer = dynamic(import('src/components/layouts/footer'));

function getTop3FirstDataByPublishedAt(categories = []) {
  if (!Array.isArray(categories)) return [];

  return categories
    .map(cat => cat?.data?.[0])
    .filter(item => item?.published_at)
    .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
    .slice(0, 3);
}
export const processCategory = async (category, apiUri, signal) => {
  const processedCategory = typeof structuredClone === 'function' ? structuredClone(category) : JSON.parse(JSON.stringify(category));

  if (!processedCategory || typeof processedCategory !== 'object') {
    console.warn('Invalid category input:', category);
    return category;
  }

  try {
    if (Array.isArray(processedCategory.sub) && processedCategory.sub.length > 0) {
      const overviewSubItem = {
        id: String(processedCategory.id),
        nameTh: processedCategory.nameTh,
        nameEng: processedCategory.nameEng,
        link: `/category/${processedCategory.nameEng}`,
        metaData: null,
        data: getTop3FirstDataByPublishedAt(processedCategory.sub)
      };

      processedCategory.sub = [overviewSubItem, ...processedCategory.sub];
    }

    // 2 กรณีเป็นหมวด 'news' → ดึงข่าวล่าสุด
    if (processedCategory.nameEng === 'news') {
      const controller = new AbortController();

      try {
        const response = await fetch(`${apiUri}/api/v1.0/categories/latest-news?limit=3`, {
          signal: signal ?? controller.signal
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const latestNewsData = await response.json();

        const allNewsSubItem = {
          id: 0,
          nameTh: 'Latest News',
          nameEng: 'latest-news',
          link: '/category/latest-news',
          metaData: null,
          data: Array.isArray(latestNewsData?.data) ? latestNewsData.data : []
        };

        processedCategory.sub = [allNewsSubItem, ...(processedCategory.sub || [])];
      } catch (error) {
        if (error.name === 'AbortError') {
          console.debug('Request aborted for news category');
        } else {
          console.error('❌ Error fetching latest news:', error);
        }
      }
    }
  } catch (err) {
    console.error(`❌ Error processing category "${category?.nameEng}":`, err);
  }

  return processedCategory;
};
const Layout = ({ children, ads, navData: navDataFromServer }) => {
  const hasServerNavData = Array.isArray(navDataFromServer) && navDataFromServer.length > 0;

  // ถ้ามีข้อมูลจาก SSR → ใช้เลยตั้งแต่ render แรก (Header มี data ตั้งแต่ HTML → ไม่มี CLS/ไม่มี waterfall)
  const [navData, setNavData] = useState(hasServerNavData ? navDataFromServer : null);

  useEffect(() => {
    // มี navData ส่งเข้ามาแล้ว → ไม่ต้องยิงซ้ำฝั่ง client
    if (hasServerNavData) return;

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URI}/api/v1.0/navigations/menu-nav`, { signal });
        const initialNavData = await res.json();

        if (!Array.isArray(initialNavData) || 'msg' in initialNavData) {
          setNavData(null);
          return;
        }

        const finalNavData = await Promise.all(initialNavData.map(category => processCategory(category, API_URI, signal)));

        setNavData(finalNavData);
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted');
        } else {
          console.error('Layout error:', error);
          setNavData(null);
        }
      }
    };

    fetchData();

    return () => controller.abort();
  }, [hasServerNavData]);

  return (
    <>
      <Header data={navData} />
      <main>{children}</main>
      <Footer data={navData} ads={ads} />
    </>
  );
};
export default Layout;
